import { getEnumValues } from '../enums';
export enum OrganizationPermission{
	TeamAdmin='team-admin',
	PlayerAdmin='player-admin',
}
export const OrganizationPermissions = getEnumValues<OrganizationPermission>(OrganizationPermission);